import {
  HiringRequestListAPIData,
  NewHiringRequestsAPIResponse,
  UpdateHiringRequestPayload,
  UpdateHiringRequestResponseData,
} from 'features/Connect/features/ConnectATSIntegration/types';
import { BaseNimbleAPI } from './baseAPI';

import { CandidateApplicationConnectData } from 'types';
import { ScorecardToSubmit } from 'features/Connect/features/ConnectATSIntegration/types/scorecardTypes';
import { HiringRequestScorecard } from 'features/Connect/features/ConnectATSIntegration/types/feedbackDetailTypes';

class HiringRequestsAPI extends BaseNimbleAPI {
  get config() {
    return { baseURL: '/api/hiring-requests' };
  }

  async getHiringRequests(page?: number): Promise<HiringRequestListAPIData> {
    const url = page ? `/?page=${page}` : '/';
    const response = await this.get(url);
    return response.data;
  }

  async updateHiringRequest(
    hiringRequestId: number,
    payload: UpdateHiringRequestPayload
  ): Promise<UpdateHiringRequestResponseData> {
    const url = `/${hiringRequestId}/`;
    const response = await this.patch(url, payload);
    return response.data;
  }

  async importCandidateFromConnect(
    payload: CandidateApplicationConnectData
  ): Promise<NewHiringRequestsAPIResponse> {
    const url = '/';
    const response = await this.post(url, payload);
    return response.data;
  }

  async checkForExistingByCandidateId(
    candidateId: number
  ): Promise<{ has_existing_hiring_request: boolean }> {
    const url = `/check-for-existing/?candidate_id=${candidateId}`;
    const response = await this.get(url);
    return response.data;
  }

  async createScorecard(
    hiringRequestId: number,
    payload: ScorecardToSubmit | FormData
  ): Promise<HiringRequestScorecard> {
    const url = `/${hiringRequestId}/scorecards/`;
    const response = await this.post(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async editScorecard(
    hiringRequestId: number,
    scorecardId: number,
    payload: ScorecardToSubmit | FormData
  ): Promise<HiringRequestScorecard> {
    const url = `/${hiringRequestId}/scorecards/${scorecardId}/`;
    const response = await this.put(url, payload, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  }

  async deleteScorecard(
    hiringRequestId: number,
    scorecardId: number
  ): Promise<HiringRequestScorecard> {
    const url = `/${hiringRequestId}/scorecards/${scorecardId}/`;
    const response = await this.delete(url);
    return response.data;
  }

  async getScorecardsForHiringRequest(id: number): Promise<HiringRequestScorecard[]> {
    const url = `/${id}/scorecards/`;
    const response = await this.get(url);
    return response.data;
  }
}

export default new HiringRequestsAPI();
